<div class="add-billing-container">
	<form [formGroup]="missingPolicyForm">
		<div class="missing-pol-sec">
			<div class="add-bill-link-policy">
				<div class="link-pol-sec">
					<div class="add-policy-row">
						<div class="add-policy-title">{{"Add a missing policy" | translate }}</div>
						<mapfre-tooltip additionalClasses="tool-tip-w" [placementLocation]="'bottom'" [desktopPlacementLocation]="'right'"
							[fullTitle]="'Where can I find my information?'"
							[description]="'Primary policyholder information, including policy number, can be found on the top right of either your last billing statement or renewal.'"
							autoCloseProp="false" [trigger]="'manual'"
							[imgPath]="isAcmic ? 'assets/img/images/acmic-tooltip-img-1.png': 'assets/img/images/tooltip-img-new.png'"
							[imageHasBody]="true">
						</mapfre-tooltip>
					</div>
					<div class="w-100">
						<input class="form-control" formControlName="missingPolicyNumber" type="text"
							placeholder="{{placeHolderText}}">
					</div>
				</div>
				<div class="add-bill-action" [ngClass]="{'w-100-mobile':!isAcmic}">
					<mapfre-button (click)="addPolicy()" [additionalClasses]="'basic primary policy-action-btn w-100-mobile'">Add
						policy
					</mapfre-button>
				</div>
			</div>
		</div>
	</form>
</div>